import React from 'react';
import theme from '@shared/utils/themeColors';

interface SelectOption {
  value: string;
  label: string;
}

interface SelectControlProps {
  id: string;
  name?: string;
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  options: SelectOption[];
  placeholder?: string;
  disabled?: boolean;
  error?: string | null;
  required?: boolean;
  className?: string;
}

const SelectControl: React.FC<SelectControlProps> = ({
  id,
  name,
  label,
  value,
  onChange,
  options,
  placeholder = 'Select an option',
  disabled = false,
  error = null,
  required = false,
  className = '',
}) => {
  return (
    <div className={className}>
      <label
        htmlFor={id}
        className={`block text-sm font-medium ${theme.text.secondary} mb-1`}
      >
        {label}{required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <select
        id={id}
        name={name || id}
        value={value}
        onChange={onChange}
        className={`form-select w-full ${error ? 'border-red-500' : ''}`}
        disabled={disabled}
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && <div className="text-red-500 text-sm mt-1">{error}</div>}
    </div>
  );
};

export default SelectControl;
